import { Youtube, Facebook, Instagram, Twitch, Send } from 'lucide-react';

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const Footer = ({ settings }) => {
  const s = settings || {};
  const facebookUrl = s.facebook_url || '';
  const instagramUrl = s.instagram_url || '';
  const xUrl = s.x_url || '';
  const youtubeUrl = s.youtube_url || '';
  const twitchUrl = s.twitch_url || '';
  const telegramUrl = s.telegram_url || '';

  const socials = [
    { url: facebookUrl, icon: <Facebook className="w-5 h-5" />, label: 'Facebook', testId: 'footer-facebook' },
    { url: instagramUrl, icon: <Instagram className="w-5 h-5" />, label: 'Instagram', testId: 'footer-instagram' },
    { url: xUrl, icon: <XIcon />, label: 'X', testId: 'footer-x' },
    { url: youtubeUrl, icon: <Youtube className="w-5 h-5" />, label: 'YouTube', testId: 'footer-youtube' },
    { url: twitchUrl, icon: <Twitch className="w-5 h-5" />, label: 'Twitch', testId: 'footer-twitch' },
    { url: telegramUrl, icon: <Send className="w-5 h-5" />, label: 'Telegram', testId: 'footer-telegram' },
  ].filter(x => x.url);

  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer-section"
      className="text-white"
      style={{ background: 'linear-gradient(180deg, #990000 0%, #770000 100%)' }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
        <div className="flex flex-col items-center gap-8 text-center">
          {/* Brand emblem */}
          <div className="flex flex-col items-center gap-3" data-testid="footer-brand">
            <img src="/circle-rd-logo.png" alt="Red Dragon Poker Tour" className="w-16 h-16 object-contain" />
            <div className="leading-none">
              <span className="block text-2xl font-bold tracking-[0.15em] uppercase">RED DRAGON</span>
              <span className="block text-[11px] font-light tracking-[0.4em] uppercase text-white/75 mt-1">Poker Tour</span>
            </div>
          </div>

          {/* Social icons */}
          {socials.length > 0 && (
            <div className="flex items-center flex-wrap justify-center gap-4">
              {socials.map(({ url, icon, label, testId }) => (
                <a
                  key={testId}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={testId}
                  aria-label={label}
                  className="w-11 h-11 rounded-full flex items-center justify-center text-white bg-white/15 hover:bg-white hover:text-[#990000] transition-all duration-300 hover:scale-110"
                >
                  {icon}
                </a>
              ))}
            </div>
          )}

          {/* Legal */}
          <div className="space-y-1.5 pt-2">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-white/90">Responsible Gaming</p>
            <p className="text-[11px] tracking-wider text-white/70 uppercase">© {year} Red Dragon Poker. All rights reserved.</p>
            <p className="text-[11px] tracking-[0.2em] text-white/60 uppercase">Your new destination for poker</p>
          </div>

          {/* Admin (subtle) */}
          <a
            href="/admin/login"
            className="text-[10px] tracking-[0.25em] uppercase text-white/40 hover:text-white transition-colors"
            data-testid="admin-login-link"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
};
